/* eslint-disable class-methods-use-this */
/* eslint-disable no-unused-vars */
/**
 * @module cercaliagl/layer/ZBE
 */
import Servers from '../servers';
import ZBEJson from './styles/ZBE.json';
/**
 * @const
 * @type {string}
 */
var LayerId = 'zbe';
/**
 * @const
 * @type {string}
 */
var SourceId = 'traffic-zbe';
/**
 * @classdesc
 */
var ZBE = /** @class */ (function () {
    /**
     * @constructor
     */
    function ZBE() {
        /**
         * @private
         * @type {string}
         */
        this.id_ = LayerId;
        /**
         * @private
         * @type {import("maplibre-gl").Map}
         */
        this.map_ = null;
        /**
         * @private
         * @type {boolean}
         */
        this.visible_ = true;
        /**
         * @private
         * @type {string}
         */
        this.beforeLayerId_ = 'poi-level-4';
        /**
         * @private
         * @type {import("maplibre-gl").Source}
         */
        this.source_ = {
            type: 'vector',
            tiles: ["".concat(Servers.hdflow)],
        };
        this.hoveredFeature_ = null;
        /**
         * @private
         * @type {Array.<Object.<string, any>>}
         */
        this.layers_ = ZBEJson.layers;
    }
    /**
     * @return {string} Id.
     */
    ZBE.prototype.getLayerId = function () {
        return this.id_;
    };
    /**
     * @param {import("../Map").default} map MAp
     */
    ZBE.prototype.setMap = function (map) {
        var _this = this;
        if (map) {
            this.map_ = map.getMapboxglMap();
            this.map_.addSource(SourceId, this.source_);
            var currentBeforeLayerId_1 = this.map_.getLayer(this.beforeLayerId_) ? this.beforeLayerId_ : null;
            this.layers_.forEach(function (layer) {
                _this.map_.addLayer(layer, currentBeforeLayerId_1);
            });
        }
        else {
            this.layers_.forEach(function (layer) {
                _this.map_.removeLayer(layer.id);
            });
            this.map_.removeSource(SourceId);
        }
    };
    /**
     * @param {boolean} visible Visible
     */
    ZBE.prototype.setVisible = function (visible) {
        var _this = this;
        this.visible_ = visible;
        this.layers_.forEach(function (layer) {
            _this.map_.setLayoutProperty(layer.id, 'visibility', _this.visible_ ? 'visible' : 'none');
        });
    };
    /**
     * @return {Array.<Object.<string, any>>} Layers
     */
    ZBE.prototype.getLayers = function () {
        return this.layers_;
    };
    return ZBE;
}());
export default ZBE;
//# sourceMappingURL=ZBE.js.map